










/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            items: []
        }
    },

    created() {
        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    activated() {
        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    mounted() {
        this.$nextTick(() => {
            this.updateOptions()
        })
    },

    computed: {

        _isFormOptGroup() {
            return true;
        },

        cClass() {
            let classes = ['form-optgroup'];

            return classes.join(' ');
        },
    },

    methods: {
        getOptions() {
            return (this.$slots.default || [])
                .map(vnode => vnode.componentInstance)
                .filter(tab => tab && tab._isFormOption || tab._isFormOptGroup)
        },

        updateOptions() {
            this.items = this.getOptions();

            this.items.forEach(item => {
                item.$off('select').$on('select', (option) => {
                    this.$emit('select', option);
                }) 
            });
        },
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class FormOptgroup extends Vue {
    @Prop() label!: string;
}

